(() => {
  const dialog = document.querySelector('[data-cart-drawer]');
  const routesElement = document.querySelector('[data-cart-routes]');
  const labelsElement = document.querySelector('[data-cart-labels]');
  if (!dialog || !routesElement || !labelsElement) return;

  const routes = JSON.parse(routesElement.textContent);
  const labels = JSON.parse(labelsElement.textContent);
  const linesElement = dialog.querySelector('[data-cart-lines]');
  const emptyElement = dialog.querySelector('[data-cart-empty]');
  const footerElement = dialog.querySelector('[data-cart-footer]');
  const savingsElement = dialog.querySelector('[data-cart-savings]');
  const savingsAmountElement = dialog.querySelector('[data-cart-savings-amount]');
  const subtotalElement = dialog.querySelector('[data-cart-subtotal]');
  const subtotalBeforeElement = dialog.querySelector('[data-cart-subtotal-before]');
  const errorElement = dialog.querySelector('[data-cart-error]');
  const statusElement = dialog.querySelector('[data-cart-status]');
  const upsellElement = dialog.querySelector('[data-cart-upsell]');
  const upsellAction = dialog.querySelector('[data-cart-upsell-action]');
  const upsellActionLabel = dialog.querySelector('[data-cart-upsell-action-label]');
  const upsellConfigElement = dialog.querySelector('[data-cart-upsell-config]');
  const upsellActionDefaultLabel = upsellActionLabel?.textContent || '';
  let upsellConfig = null;
  let renderedCart = null;
  let renderedGroups = [];
  let lastTrigger = null;
  let activeRequest = 0;
  const productPriceCache = new Map();

  if (upsellConfigElement) {
    try {
      upsellConfig = JSON.parse(upsellConfigElement.textContent);
    } catch {
      upsellConfig = null;
    }
  }

  function formatLabel(template, variables) {
    return Object.entries(variables).reduce((result, [key, value]) => result.replaceAll(`__${key.toUpperCase()}__`, String(value)), template);
  }

  function formatMoney(cents, currency) {
    return globalThis.KiddyViewProductLogic.formatMoney(cents, currency, document.documentElement.lang);
  }

  function createButton(label, action, icon) {
    const button = document.createElement('button');
    button.className = `cart-quantity__button cart-quantity__button--${action}`;
    button.type = 'button';
    button.dataset.cartAction = action;
    button.setAttribute('aria-label', label);
    button.textContent = icon;
    return button;
  }

  function createCartLine(item, line, currency) {
    const article = document.createElement('article');
    article.className = 'cart-line';
    article.dataset.cartLine = String(line);
    article.dataset.cartKeys = JSON.stringify(item._cartKeys);

    const mediaLink = document.createElement('a');
    mediaLink.className = 'cart-line__media';
    mediaLink.href = item.url;
    if (item.image) {
      const image = document.createElement('img');
      image.src = item.image;
      image.alt = item.product_title;
      image.width = 112;
      image.height = 112;
      image.loading = 'lazy';
      mediaLink.append(image);
    }

    const content = document.createElement('div');
    content.className = 'cart-line__content';
    const title = document.createElement('a');
    title.className = 'cart-line__title';
    title.href = item.url;
    title.textContent = item.product_title;
    content.append(title);
    if (item.variant_title && item.variant_title !== 'Default Title') {
      const variant = document.createElement('p');
      variant.className = 'cart-line__variant';
      variant.textContent = item.variant_title;
      content.append(variant);
    }

    const controls = document.createElement('div');
    controls.className = 'cart-line__controls';
    const quantity = document.createElement('div');
    quantity.className = 'cart-quantity';
    const quantityLabel = formatLabel(labels.quantityFor, { product: item.product_title });
    quantity.append(createButton(labels.decrease, 'decrease', '−'));
    const value = document.createElement('input');
    value.className = 'cart-quantity__input';
    value.type = 'number';
    value.min = '0';
    value.step = '1';
    value.value = String(item.quantity);
    value.dataset.cartQuantity = '';
    value.setAttribute('aria-label', quantityLabel);
    quantity.append(value, createButton(labels.increase, 'increase', '+'));
    const remove = document.createElement('button');
    remove.className = 'cart-line__remove';
    remove.type = 'button';
    remove.dataset.cartAction = 'remove';
    remove.textContent = labels.remove;
    controls.append(quantity, remove);

    const price = document.createElement('div');
    price.className = 'cart-line__price';
    const priceState = globalThis.KiddyViewCartLogic?.getLinePriceState(item) ?? {
      originalLinePrice: Number(item.original_line_price) || 0,
      finalLinePrice: Number(item.final_line_price) || 0,
      isDiscounted: Number(item.original_line_price) > Number(item.final_line_price)
    };
    if (priceState.isDiscounted) {
      const originalPrice = document.createElement('del');
      originalPrice.className = 'cart-line__price-before';
      originalPrice.textContent = formatMoney(priceState.originalLinePrice, currency);
      price.append(originalPrice);
    }
    const finalPrice = document.createElement('strong');
    finalPrice.className = `cart-line__price-now${priceState.isDiscounted ? ' cart-line__price-now--discounted' : ''}`;
    finalPrice.textContent = formatMoney(priceState.finalLinePrice, currency);
    price.append(finalPrice);
    content.append(controls);
    article.append(mediaLink, content, price);
    return article;
  }

  function updateCartCounts(count) {
    document.querySelectorAll('[data-cart-count]').forEach((badge) => {
      badge.textContent = String(count);
      badge.hidden = count === 0;
    });
    document.querySelectorAll('[data-cart-open]').forEach((trigger) => {
      trigger.setAttribute('aria-label', count > 0 ? formatLabel(labels.cartCount, { count }) : labels.cartTitle);
    });
  }

  function renderUpsell(cart) {
    if (!upsellElement) return;
    const isEligible = Boolean(
      upsellConfig && globalThis.KiddyViewCartLogic?.isUpsellEligible(cart, upsellConfig)
    );
    upsellElement.hidden = !isEligible;
  }

  function renderCart(cart) {
    renderedCart = cart;
    renderedGroups = globalThis.KiddyViewCartLogic?.groupCartItems(cart.items)
      ?? cart.items.map((item) => ({ ...item, _cartKeys: [item.key] }));
    linesElement.replaceChildren(...renderedGroups.map((item, index) => createCartLine(item, index + 1, cart.currency)));
    const isEmpty = cart.item_count === 0;
    emptyElement.hidden = !isEmpty;
    footerElement.hidden = isEmpty;
    const discount = globalThis.KiddyViewCartLogic?.getAppliedDiscount(cart) ?? 0;
    savingsElement.hidden = discount === 0;
    savingsAmountElement.textContent = discount > 0 ? `− ${formatMoney(discount, cart.currency)}` : '';
    const comparisonTotal = renderedGroups.reduce((total, item) => {
      const priceState = globalThis.KiddyViewCartLogic.getLinePriceState(item);
      return total + priceState.originalLinePrice;
    }, 0);
    if (subtotalBeforeElement) {
      subtotalBeforeElement.hidden = comparisonTotal <= cart.total_price;
      subtotalBeforeElement.textContent = comparisonTotal > cart.total_price ? formatMoney(comparisonTotal, cart.currency) : '';
      subtotalBeforeElement.parentElement.classList.toggle('is-discounted', comparisonTotal > cart.total_price);
    }
    subtotalElement.textContent = formatMoney(cart.total_price, cart.currency);
    renderUpsell(cart);
    updateCartCounts(cart.item_count);
    statusElement.textContent = formatLabel(labels.updated, { count: cart.item_count });
  }

  function setError(message = '') {
    errorElement.textContent = message;
    errorElement.hidden = message.length === 0;
  }

  async function request(url, options = {}) {
    const response = await fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json', ...options.headers },
      ...options
    });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(payload.description || payload.message || labels.cartError);
    return payload;
  }

  async function withCompareAtPrices(cart) {
    // Cart Ajax omits variant compare-at prices; load them in the current storefront currency.
    const root = routes.cartPage.replace(/\/cart\/?$/, '');
    const items = await Promise.all(cart.items.map(async (item) => {
      if (!item.handle) return item;
      const url = `${root}/products/${encodeURIComponent(item.handle)}.js`;
      const cacheKey = `${cart.currency}:${url}`;
      if (!productPriceCache.has(cacheKey)) {
        productPriceCache.set(cacheKey, request(url).catch(() => {
          productPriceCache.delete(cacheKey);
          return null;
        }));
      }
      const product = await productPriceCache.get(cacheKey);
      const variant = product?.variants?.find((candidate) => String(candidate.id) === String(item.variant_id));
      return { ...item, compare_at_price: Number(variant?.compare_at_price) || 0 };
    }));
    return { ...cart, items };
  }

  function openDrawer(trigger) {
    lastTrigger = trigger || document.activeElement;
    document.body.classList.add('cart-drawer-open');
    if (!dialog.open) dialog.showModal();
    dialog.querySelector('[data-cart-close]')?.focus();
  }

  function closeDrawer() {
    if (dialog.open) dialog.close();
  }

  async function refreshCart({ open = false, trigger = null } = {}) {
    const requestId = ++activeRequest;
    const cart = await fetch(routes.cartJson, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(async (response) => {
      const payload = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(payload.description || payload.message || labels.cartError);
      return payload;
    });
    const pricedCart = await withCompareAtPrices(cart);
    if (requestId === activeRequest) {
      renderCart(pricedCart);
      if (open) openDrawer(trigger);
    }
    return pricedCart;
  }

  async function addItem(form, submitter) {
    const productRoot = form.closest('[data-product-root]');
    if (form.dataset.submitting === 'true' || productRoot?.dataset.productAvailable === 'false') return;
    if (!form.reportValidity()) return;
    const requestBody = new FormData(form);
    const controls = [...form.elements].filter((control) => control.matches('[data-product-submit], input[data-quantity], [data-compatibility-confirmation], [data-sticky-toggle], [data-sticky-quantity]'));
    const states = controls.map((control) => ({ control, disabled: control.disabled, label: control.querySelector('[data-cart-label]'), text: control.querySelector('[data-cart-label]')?.textContent }));
    form.dataset.submitting = 'true';
    form.setAttribute('aria-busy', 'true');
    states.forEach(({ control, label }) => {
      control.disabled = true;
      if (control.matches('[data-product-submit]')) {
        control.dataset.loading = 'true';
        control.setAttribute('aria-busy', 'true');
        if (label) label.textContent = labels.adding;
      }
    });
    setError();
    const sticky = document.getElementById(form.dataset.stickyId || '');
    const productErrors = [form.querySelector('[data-product-error]'), sticky?.querySelector('[data-sticky-error]')].filter(Boolean);
    productErrors.forEach((element) => { element.hidden = true; });
    try {
      await fetch(routes.cartAdd, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        body: requestBody
      }).then(async (response) => {
        const payload = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(payload.description || payload.message || labels.addError);
        return payload;
      });
      await refreshCart({ open: true, trigger: submitter });
    } catch (error) {
      productErrors.forEach((element) => {
        element.textContent = error.message;
        element.hidden = false;
      });
    } finally {
      delete form.dataset.submitting;
      form.removeAttribute('aria-busy');
      states.forEach(({ control, disabled, label, text }) => {
        control.disabled = disabled || (control.matches('[data-product-submit]') && productRoot?.dataset.productAvailable === 'false');
        delete control.dataset.loading;
        control.removeAttribute('aria-busy');
        if (label) label.textContent = text;
      });
    }
  }

  async function changeGroup(keys, quantity) {
    const requestId = ++activeRequest;
    const lineElement = [...linesElement.querySelectorAll('[data-cart-line]')]
      .find((element) => JSON.parse(element.dataset.cartKeys || '[]')[0] === keys[0]);
    lineElement?.setAttribute('aria-busy', 'true');
    lineElement?.setAttribute('data-loading', 'true');
    setError();
    try {
      const updates = Object.fromEntries(keys.map((key, index) => [key, index === 0 ? quantity : 0]));
      const cart = await fetch(routes.cartUpdate, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      }).then(async (response) => {
        const payload = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(payload.description || payload.message || labels.cartError);
        return payload;
      });
      const pricedCart = await withCompareAtPrices(cart);
      if (requestId === activeRequest) renderCart(pricedCart);
      return pricedCart;
    } catch (error) {
      setError(error.message);
      await refreshCart();
      throw error;
    } finally {
      lineElement?.removeAttribute('aria-busy');
      lineElement?.removeAttribute('data-loading');
    }
  }

  async function upgradeCart() {
    if (
      !upsellConfig ||
      !upsellAction ||
      !globalThis.KiddyViewCartLogic?.isUpsellEligible(renderedCart, upsellConfig)
    ) return;

    upsellAction.disabled = true;
    upsellAction.dataset.loading = 'true';
    if (upsellActionLabel) upsellActionLabel.textContent = labels.upsellLoading;
    setError();

    try {
      const item = renderedGroups.find((candidate) => candidate.handle === upsellConfig.productHandle);
      if (!item) return;
      await changeGroup(item._cartKeys, 2);
      statusElement.textContent = labels.upsellSuccess;
    } catch (error) {
      setError(error.message);
      await refreshCart();
      throw error;
    } finally {
      upsellAction.disabled = false;
      delete upsellAction.dataset.loading;
      if (upsellActionLabel) upsellActionLabel.textContent = upsellActionDefaultLabel;
    }
  }

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;
    const submitter = event.submitter || form.querySelector('[data-product-submit]');
    if (!submitter) return;
    event.preventDefault();
    addItem(form, submitter);
  });

  document.addEventListener('click', (event) => {
    const pageDecrease = event.target.closest('[data-cart-page-decrease]');
    const pageIncrease = event.target.closest('[data-cart-page-increase]');
    if (pageDecrease || pageIncrease) {
      const input = event.target.closest('.cart-quantity')?.querySelector('input[name="updates[]"]');
      if (!input) return;
      const nextQuantity = Number(input.value) + (pageIncrease ? 1 : -1);
      input.value = String(Math.max(0, nextQuantity));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    const openTrigger = event.target.closest('[data-cart-open]');
    if (openTrigger) {
      event.preventDefault();
      setError();
      refreshCart({ open: true, trigger: openTrigger }).catch((error) => setError(error.message));
      return;
    }
    if (event.target.closest('[data-cart-close]')) closeDrawer();
  });

  linesElement.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cart-action]');
    const lineElement = button?.closest('[data-cart-line]');
    if (!button || !lineElement || lineElement.dataset.loading === 'true') return;
    const keys = JSON.parse(lineElement.dataset.cartKeys || '[]');
    const input = lineElement.querySelector('[data-cart-quantity]');
    const current = Number(input.value);
    const next = button.dataset.cartAction === 'increase' ? current + 1 : button.dataset.cartAction === 'decrease' ? Math.max(0, current - 1) : 0;
    changeGroup(keys, next).catch(() => {});
  });

  linesElement.addEventListener('change', (event) => {
    const input = event.target.closest('[data-cart-quantity]');
    const lineElement = input?.closest('[data-cart-line]');
    if (!input || !lineElement || lineElement.dataset.loading === 'true') return;
    const keys = JSON.parse(lineElement.dataset.cartKeys || '[]');
    changeGroup(keys, Math.max(0, Number(input.value) || 0)).catch(() => {});
  });

  dialog.addEventListener('click', (event) => {
    if (event.target.closest('[data-cart-upsell-action]')) {
      event.preventDefault();
      upgradeCart().catch(() => {});
      return;
    }
    if (event.target === dialog) closeDrawer();
  });
  dialog.addEventListener('cancel', (event) => {
    event.preventDefault();
    closeDrawer();
  });
  dialog.addEventListener('close', () => {
    document.body.classList.remove('cart-drawer-open');
    lastTrigger?.focus();
    lastTrigger = null;
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && dialog.open) closeDrawer();
  });

  window.KiddyViewCart = { open: openDrawer, close: closeDrawer, refresh: refreshCart };
})();
